import { render, staticRenderFns } from "./RelTermoDevolBemMovel.vue?vue&type=template&id=a20743f8&"
import script from "./RelTermoDevolBemMovel.vue?vue&type=script&lang=js&"
export * from "./RelTermoDevolBemMovel.vue?vue&type=script&lang=js&"
import style0 from "./RelTermoDevolBemMovel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports